<template>
  <Disclosure as="div" :class="[hasChildren ? 'mb-2' : 'mr-1', navItem.externalWrapperClass]" v-slot="{ open }" :defaultOpen="new Boolean(navItem.current)">
    <DisclosureButton
        :class="[navItem.current ? 'bg-gradient-to-r from-gray-100 to-transparent tracking-wide text-secondary font-bold border-r-past-blue' : 'text-gray-900 hover:bg-gray-50 hover:text-gray-900 ', 'border-transparent  group w-full flex items-center pr-1 py-2 text-left font-medium rounded-md focus:outline-none  border-2']"
        @click="(navItem.onClick !== undefined) ? navItem.onClick(this, navItem.current) : ''"
    >
      <!--        :class="[navItem.current ? 'text-gray-900 italic' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900', 'group w-full flex items-center pr-1 py-2 text-left font-medium rounded-md focus:outline-none  border-2 border-transparent focus:border-primary']"-->
      <svg v-if="navItem.children"
           :class="[open ? 'text-gray-900 rotate-90' : 'text-gray-900', 'flex-shrink-0 h-4 w-4 transform  transition-colors ease-in-out duration-150']"
           viewBox="0 0 20 20"
           aria-hidden="true">
        <path d="M6 6L14 10L6 14V6Z" fill="currentColor"/>
      </svg>
      <component :is="navItem.icon"
                 :class="[navItem.current ? 'text-secondary' : 'text-gray-900']"
                 class="flex-shrink-0 mr-2 w-5 h-5 " aria-hidden="true"/>
<!--      :class="[navItem.current ? 'text-gray-900' : 'text-gray-400']"-->

      <span v-if="menuEntryToEdit !== navItem.id" class="flex-1 overflow-ellipsis">
        {{ navItem.name }}
      </span>
      <input v-else
             type="text"
             :name="`edit-menu-entry-${navItem.id}`"
             :id="`edit-menu-entry-${navItem.id}`"
             :ref="`edit-menu-entry-${navItem.id}`"
             class="sm:text-base block w-full p-0 bg-gray-50 border-0 border-b border-transparent border-primary focus:border-primary focus:ring-0 sm:text-sm"
             v-model.trim="newMenuEntryNames[`${navItem.id}`]"
             @keydown.space.stop
             @keydown.enter.prevent
             @keyup.enter="validNewMenuName($event, navItem)"
             @keyup.esc="$store.commit('editMenuEntry', null)"
             @blur="$store.commit('editMenuEntry', null)"
             @click.stop
      />

      <span v-if="navItem.count" :class="[navItem.current ? '' : 'bg-gray-10 group-hover:bg-gray-20', 'ml-3 inline-block py-0.5 px-3 text-xs font-medium rounded-full']">
        {{ navItem.count }}
      </span>


      <div v-if="navItem.actions"
           class="flex flex-shrink-0 self-center font-normal"
           :class="{'mr-1' : navItem.children}"
           @click.stop>
        <Menu as="div" class="inline-block text-left ">
          <div>
            <MenuButton
                class="flex items-center p-2 -m-2 text-gray-400 rounded-full hover:text-gray-600 focus:outline-none border-2 border-transparent focus:border-primary">
              <span class="sr-only">Open options</span>
              <DotsVerticalIcon class="w-5 h-5" aria-hidden="true"/>
            </MenuButton>
          </div>

          <transition enter-active-class="transition duration-100 ease-out"
                      enter-from-class="opacity-0 transform scale-95" enter-to-class="opacity-100 transform scale-100"
                      leave-active-class="transition duration-75 ease-in"
                      leave-from-class="opacity-100 transform scale-100" leave-to-class="opacity-0 transform scale-95">
            <MenuItems
                class="absolute right-1 mt-2 bg-white rounded-md ring-1 ring-black ring-opacity-5 shadow-lg origin-top-right focus:outline-none  min-w-1/2">
              <div class="py-1">

                <MenuItem v-slot="{ active }" v-for="action in navItem.actions" :key="`${navItem.id}-${action.name}`">
                  <a v-if="action.onClickCallback === undefined"
                     :href="typeof action.href === 'undefined' ? '#' : action.href"
                     :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'flex px-4 py-2 text-sm']">
                    <component :is="action.icon" class="mr-3 w-4 h-4" :class="action.iconClass" aria-hidden="true"/>
                    <span>{{ action.name }}</span>
                  </a>
                  <button v-else
                          @click="action.onClickCallback(this)"
                          :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'flex items-center px-4 py-2 text-sm w-full', {'border-t': action.divider === 'top', 'border-b': action.divider === 'bottom', 'border-t border-b': action.divider === 'both'}]">
                    <component :is="action.icon" class="mr-3 w-4 h-4" :class="action.iconClass" aria-hidden="true"/>
                    <span>{{ action.name }}</span>
                  </button>
                </MenuItem>

              </div>
            </MenuItems>
          </transition>
        </Menu>
      </div>

    </DisclosureButton>
    <!--    <DisclosurePanel class="space-y-1">          -->
    <DisclosurePanel class="py-1" v-if="hasChildren">


      <template v-for="subItem in navItem.children" :key="subItem.name">
        <a v-if="subItem.onClickCallback === undefined"
           :href="subItem.href"
           class="group w-full flex items-center text-left pl-12 pr-2 py-1.5 text-sm font-medium rounded-md hover:bg-gray-50 focus:outline-none border-2 border-transparent"
           :class="[subItem.current ? 'rounded-tl-none rounded-bl-none bg-ternary-100 border-l-4 border-l-ternary tracking-wide font-bold text-secondary text-shadow' : 'text-gray-900 focus:border-transparent']">
          <span class="flex-1 overflow-ellipsis">
            {{ subItem.name }}
          </span>
          <span v-if="subItem.count"
                :class="[subItem.current ? '' : '', 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800']">
            {{ subItem.count }}
          </span>
        </a>

        <button v-else
                @click="subItem.onClickCallback(this);"
                @mouseenter="displayActionsMenu = subItem.name"
                @mouseleave="displayActionsMenu = null"
                class="group w-full flex items-center text-left pl-12 pr-2 py-1.5 text-sm font-medium rounded-md focus:outline-none border-2 border-transparent "
                :class="[subItem.current ? 'rounded-tl-none rounded-bl-none bg-ternary-100 border-l-4 border-l-ternary tracking-wide font-bold text-secondary text-shadow' : 'hover:bg-gray-50 text-gray-900 focus:border-transparent']">


          <span v-if="menuEntryToEdit !== subItem.id"  class="flex-1 overflow-ellipsis ">
            {{ subItem.name }}
          </span>
          <input v-else
                 type="text"
                 :name="`edit-menu-entry-${subItem.id}`"
                 :id="`edit-menu-entry-${subItem.id}`"
                 :ref="`edit-menu-entry-${subItem.id}`"
                 class="text-sm font-medium block w-full p-0 bg-gray-50 border-0 border-b border-transparent border-primary focus:border-primary focus:ring-0"
                 v-model.trim="newMenuEntryNames[`${subItem.id}`]"
                 @keyup.space.prevent
                 @keydown.enter.prevent
                 @keyup.enter.stop="validNewMenuName($event, subItem)"
                 @keyup.esc.stop="$store.commit('editMenuEntry', null)"
                 @blur="$store.commit('editMenuEntry', null)"
                 @click.stop
          />


          <span v-if="subItem.count  && !subItem.actions"
                :class="[subItem.current ? '' : '', 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-800']"
          >
            {{ subItem.count }}
          </span>


          <div v-if="subItem.actions" class="flex flex-shrink-0 self-center font-normal" @click.stop>
            <Menu as="div" class="inline-block text-left">
              <div>
                <MenuButton
                    class="flex items-center pl-2 -m-2 text-gray-400 rounded-full hover:text-gray-600 focus:outline-none border-2 border-transparent focus:border-0">

                  <span v-if="subItem.count  && this.displayActionsMenu !== subItem.name"
                        :class="[subItem.current ? 'mr-1' : '', 'inline-flex items-center px-2.5 mr-1 py-0.5 rounded-full text-xs font-medium text-gray-800']"
                  >
                    {{ subItem.count }}
                  </span>

                  <span v-else>
                    <span class="sr-only">Open options</span>
                    <DotsVerticalIcon class="w-5 h-5 mr-2" aria-hidden="true"/>
                  </span>

                </MenuButton>
              </div>

              <transition enter-active-class="transition duration-100 ease-out"
                          enter-from-class="opacity-0 transform scale-95" enter-to-class="opacity-100 transform scale-100"
                          leave-active-class="transition duration-75 ease-in"
                          leave-from-class="opacity-100 transform scale-100" leave-to-class="opacity-0 transform scale-95">
                <MenuItems
                    class="absolute right-1 mt-2 bg-white rounded-md ring-1 ring-black ring-opacity-5 shadow-lg origin-top-right focus:outline-none min-w-1/2">
                  <div class="py-1">

                    <MenuItem v-slot="{ active }" v-for="action in subItem.actions" :key="`${subItem.id}-${action.name}`">
                      <a v-if="action.onClickCallback === undefined"
                         :href="typeof action.href === 'undefined' ? '#' : action.href"
                         :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'flex px-4 py-2 text-sm']">
                        <component :is="action.icon" class="mr-3 w-4 h-4" :class="action.iconClass" aria-hidden="true"/>
                        <span>{{ action.name }}</span>
                      </a>
                      <button v-else
                              @click="action.onClickCallback(this)"
                              :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'flex items-center px-4 py-2 text-sm w-full', {'border-t': action.divider === 'top', 'border-b': action.divider === 'bottom', 'border-t border-b': action.divider === 'both'}]">
                        <component :is="action.icon" class="mr-3 w-4 h-4" :class="action.iconClass" aria-hidden="true"/>
                        <span>{{ action.name }}</span>
                      </button>
                    </MenuItem>

                  </div>
                </MenuItems>
              </transition>
            </Menu>
          </div>




        </button>
      </template>




<!--      <button v-for="subItem in navItem.children"-->
<!--         :key="subItem.name"-->
<!--         class="group w-full flex items-center text-left pl-12 pr-2 py-1.5 text-sm font-medium rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary"-->
<!--         :class="[subItem.current ? 'text-ternary-200-c bg-ternary-200 tracking-wide' : 'text-gray-600 hover:text-gray-900']">-->

<!--        <span class="flex-1 overflow-ellipsis">-->
<!--          {{ subItem.name }}-->
<!--        </span>-->
<!--        <span v-if="subItem.count"-->
<!--          :class="[subItem.current ? '' : 'bg-gray-10 group-hover:bg-gray-20', false?'ml-3 inline-block py-0.5 px-3 text-xs font-medium rounded-full':'', 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800']">-->
<!--          {{ subItem.count }}-->
<!--        </span>-->
<!--      </button>-->


    </DisclosurePanel>
  </Disclosure>
</template>

<script>
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Popover, PopoverButton, PopoverPanel
} from '@headlessui/vue'
import {
  DotsVerticalIcon
} from "@heroicons/vue/solid";
import _get from "lodash/get";

export default {
  name: "ComplexItemNav",
  props: ["navItem"],
  components: {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Popover,
    PopoverButton,
    PopoverPanel,
    DotsVerticalIcon,
  },
  data() {
    return {
      newMenuEntryNames: {},
      displayActionsMenu: null
    }
  },
  beforeUpdate() {
    this.newMenuEntryNames[this.navItem.id] = this.navItem.name;
    for (const childrenKey in this.navItem.children) {
      this.newMenuEntryNames[this.navItem.children[childrenKey].id] = this.navItem.children[childrenKey].name;
    }
  },
  methods: {
    validNewMenuName(evt, menuEntryObject) {
      if (this.newMenuEntryNames[menuEntryObject.id] === menuEntryObject.name) {
        this.$store.commit('editMenuEntry', null);
        return;
      }

      const meta = _get(this.$store.state.editEntryMenu, 'meta', null);

      let data = {};
      data[meta.idPropertyName] = _get(this.$store.state.editEntryMenu, 'id', null);
      data[meta.targetPropertyName] = this.newMenuEntryNames[menuEntryObject.id];

      this.$store.dispatch(meta.callbackName, data);
      this.$store.commit('editMenuEntry', null);
    },
  },
  computed: {
    hasChildren() {
      return Array.isArray(this.navItem.children) && this.navItem.children.length > 0
    },
    menuEntryToEdit() {
      return _get(this.$store.state.editEntryMenu, 'id', null);
    },
  }
}
</script>